import { c as _c } from "react/compiler-runtime";
import IconDeferred from '@/assets/icons/heroIcons/Deferred-payment.svg';
import IconThird from '@/assets/icons/heroIcons/Icon-third.svg';
import IconCard from '@/assets/icons/heroIcons/Card-front.svg';
import IconWarranty from '@/assets/icons/heroIcons/Warranty.svg';
import Mini from '@/assets/icons/heroIcons/Mini.svg';
import Maxi from '@/assets/icons/heroIcons/Maxi.svg';
import IconInstallments from '@/assets/icons/heroIcons/Installments.svg';
import IconExtend from '@/assets/icons/heroIcons/Extend.svg';
import IconPayment from '@/assets/icons/heroIcons/Payment.svg';
import IconLoan from '@/assets/icons/heroIcons/Loan.svg';
import IconChevronRight from '@/assets/icons/heroIcons/Chevron-right.svg';
import IconTulip from '@/assets/icons/heroIcons/Tulip.svg';
import { FilledButton } from '@/components/buttons';
import React, { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { LINKS } from '@/constants/links';
import { Text, Headline } from '@/components/typography';
import { Link } from '@/components/links';
import { showSpringOffer } from '@/utils/springOffer';
interface BoxProps {
  icon: React.JSX.Element;
  title: string;
  subtitle?: string;
  text: string;
  footer?: React.JSX.Element;
  badge?: string;
  className?: string;
}
function Box(props) {
  const $ = _c(25);
  const t0 = `relative h-full w-full rounded-2xl bg-white px-8 py-8 md:rounded-4xl md:py-10 ${props.className ?? ""}`;
  let t1;
  if ($[0] !== props.badge) {
    t1 = props.badge && <span className="absolute top-0 right-8 z-10 -translate-y-1/2 rounded-full bg-blue-500 px-4 py-1 text-xs font-semibold text-white">{props.badge}</span>;
    $[0] = props.badge;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props.icon) {
    t2 = <div className="shrink-0 text-blue-500">{props.icon}</div>;
    $[2] = props.icon;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props.title) {
    t3 = <Headline as="h2" variant="h4" className="text-2xl font-bold lg:text-3xl">{props.title}</Headline>;
    $[4] = props.title;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="mb-4 flex flex-row items-center gap-4">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== props.text) {
    t5 = <Text variant="p3" className="mb-8 text-gray-800">{props.text}</Text>;
    $[9] = props.text;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== props.subtitle) {
    t6 = props.subtitle ? <Text variant="p3" className="mb-4 font-semibold">{props.subtitle}</Text> : null;
    $[11] = props.subtitle;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== props.children) {
    t7 = <div className="-mx-2 flex flex-col gap-2">{props.children}</div>;
    $[13] = props.children;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== props.footer) {
    t8 = props.footer && <div className="mt-6">{props.footer}</div>;
    $[15] = props.footer;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t0 || $[18] !== t1 || $[19] !== t4 || $[20] !== t5 || $[21] !== t6 || $[22] !== t7 || $[23] !== t8) {
    t9 = <div className={t0}>{t1}{t4}{t5}{t6}{t7}{t8}</div>;
    $[17] = t0;
    $[18] = t1;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
}
export function ProductBoxes() {
  const $ = _c(128);
  const {
    t
  } = useTranslation("ourProducts");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = showSpringOffer();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const shouldShowSpringOffer = t0;
  let t1;
  if ($[1] !== t) {
    t1 = t("products.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <Headline as="h1" id="products" variant="h1" className="mb-13 text-center text-2xl font-bold text-white lg:text-3xl">{t1}</Headline>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Mini className="h-12 w-12" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("products.mini.title");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("products.mini.text");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <IconDeferred className="h-7 w-7" />;
    t7 = LINKS();
    $[10] = t6;
    $[11] = t7;
  } else {
    t6 = $[10];
    t7 = $[11];
  }
  const t8 = t7.deferredPayment;
  let t9;
  if ($[12] !== t) {
    t9 = t("products.deferredPayment.title");
    $[12] = t;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t9) {
    t10 = {
      icon: t6,
      to: t8,
      testId: "ourProductsTableDeferredPayment",
      analyticsParam: "ourProductsTableDeferredPayment",
      title: t9
    };
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <IconThird className="h-7 w-7" />;
    t12 = LINKS();
    $[16] = t11;
    $[17] = t12;
  } else {
    t11 = $[16];
    t12 = $[17];
  }
  const t13 = t12.payInThree;
  let t14;
  if ($[18] !== t) {
    t14 = t("products.payInThree.title");
    $[18] = t;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t14) {
    t15 = {
      icon: t11,
      to: t13,
      testId: "ourProductsTablePayInThree",
      analyticsParam: "ourProductsTablePayInThree",
      title: t14
    };
    $[20] = t14;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  let t17;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <IconLoan className="h-7 w-7" />;
    t17 = LINKS();
    $[22] = t16;
    $[23] = t17;
  } else {
    t16 = $[22];
    t17 = $[23];
  }
  const t18 = t17.loan;
  let t19;
  if ($[24] !== t) {
    t19 = t("products.loan.title");
    $[24] = t;
    $[25] = t19;
  } else {
    t19 = $[25];
  }
  let t20;
  if ($[26] !== t19) {
    t20 = {
      icon: t16,
      to: t18,
      testId: "ourProductsTableLoan",
      analyticsParam: "ourProductsTableLoan",
      title: t19
    };
    $[26] = t19;
    $[27] = t20;
  } else {
    t20 = $[27];
  }
  let t21;
  let t22;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <IconWarranty className="h-7 w-7" />;
    t22 = LINKS();
    $[28] = t21;
    $[29] = t22;
  } else {
    t21 = $[28];
    t22 = $[29];
  }
  const t23 = t22.insuranceAndWarranty;
  let t24;
  if ($[30] !== t) {
    t24 = t("products.warranty.title");
    $[30] = t;
    $[31] = t24;
  } else {
    t24 = $[31];
  }
  let t25;
  if ($[32] !== t24) {
    t25 = {
      icon: t21,
      to: t23,
      testId: "ourProductsTableWarranty",
      analyticsParam: "ourProductsTableWarranty",
      title: t24
    };
    $[32] = t24;
    $[33] = t25;
  } else {
    t25 = $[33];
  }
  let t26;
  if ($[34] !== t10 || $[35] !== t15 || $[36] !== t20 || $[37] !== t25) {
    t26 = [t10, t15, t20, t25].map(_temp);
    $[34] = t10;
    $[35] = t15;
    $[36] = t20;
    $[37] = t25;
    $[38] = t26;
  } else {
    t26 = $[38];
  }
  let t27;
  if ($[39] !== t26 || $[40] !== t4 || $[41] !== t5) {
    t27 = <Box icon={t3} title={t4} text={t5}>{t26}</Box>;
    $[39] = t26;
    $[40] = t4;
    $[41] = t5;
    $[42] = t27;
  } else {
    t27 = $[42];
  }
  let t28;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <Maxi className="h-12 w-12" />;
    $[43] = t28;
  } else {
    t28 = $[43];
  }
  let t29;
  if ($[44] !== t) {
    t29 = t("products.revolving.title");
    $[44] = t;
    $[45] = t29;
  } else {
    t29 = $[45];
  }
  let t30;
  if ($[46] !== t) {
    t30 = t("products.revolving.text");
    $[46] = t;
    $[47] = t30;
  } else {
    t30 = $[47];
  }
  let t31;
  if ($[48] !== t) {
    t31 = t("products.favourite");
    $[48] = t;
    $[49] = t31;
  } else {
    t31 = $[49];
  }
  let t32;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = LINKS();
    $[50] = t32;
  } else {
    t32 = $[50];
  }
  const t33 = t32.revolving;
  let t34;
  if ($[51] !== t) {
    t34 = t("products.revolving.cta");
    $[51] = t;
    $[52] = t34;
  } else {
    t34 = $[52];
  }
  let t35;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <IconChevronRight className="h-5 w-5" />;
    $[53] = t35;
  } else {
    t35 = $[53];
  }
  let t36;
  if ($[54] !== t34) {
    t36 = <Link to={t33} analyticsParam="revolvingCTA" testId="revolvingCTA"><div className="flex flex-row items-center">{t34}{t35}</div></Link>;
    $[54] = t34;
    $[55] = t36;
  } else {
    t36 = $[55];
  }
  let t37;
  let t38;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <IconDeferred className="h-7 w-7" />;
    t38 = LINKS();
    $[56] = t37;
    $[57] = t38;
  } else {
    t37 = $[56];
    t38 = $[57];
  }
  const t39 = t38.deferredPayment;
  let t40;
  if ($[58] !== t) {
    t40 = t("products.deferredPayment.title");
    $[58] = t;
    $[59] = t40;
  } else {
    t40 = $[59];
  }
  let t41;
  if ($[60] !== t40) {
    t41 = {
      icon: t37,
      to: t39,
      testId: "ourProductsTableDeferredPayment",
      analyticsParam: "ourProductsTableDeferredPayment",
      title: t40
    };
    $[60] = t40;
    $[61] = t41;
  } else {
    t41 = $[61];
  }
  let t42;
  let t43;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = <IconThird className="h-7 w-7" />;
    t43 = LINKS();
    $[62] = t42;
    $[63] = t43;
  } else {
    t42 = $[62];
    t43 = $[63];
  }
  const t44 = t43.payInThree;
  let t45;
  if ($[64] !== t) {
    t45 = t("products.payInThree.title");
    $[64] = t;
    $[65] = t45;
  } else {
    t45 = $[65];
  }
  let t46;
  if ($[66] !== t45) {
    t46 = {
      icon: t42,
      to: t44,
      testId: "ourProductsTablePayInThree",
      analyticsParam: "ourProductsTablePayInThree",
      title: t45
    };
    $[66] = t45;
    $[67] = t46;
  } else {
    t46 = $[67];
  }
  let t47;
  let t48;
  if ($[68] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = <IconLoan className="h-7 w-7" />;
    t48 = LINKS();
    $[68] = t47;
    $[69] = t48;
  } else {
    t47 = $[68];
    t48 = $[69];
  }
  const t49 = t48.loan;
  let t50;
  if ($[70] !== t) {
    t50 = t("products.loan.title");
    $[70] = t;
    $[71] = t50;
  } else {
    t50 = $[71];
  }
  let t51;
  if ($[72] !== t50) {
    t51 = {
      icon: t47,
      to: t49,
      testId: "ourProductsTableLoan",
      analyticsParam: "ourProductsTableLoan",
      title: t50
    };
    $[72] = t50;
    $[73] = t51;
  } else {
    t51 = $[73];
  }
  let t52;
  let t53;
  if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
    t52 = <IconWarranty className="h-7 w-7" />;
    t53 = LINKS();
    $[74] = t52;
    $[75] = t53;
  } else {
    t52 = $[74];
    t53 = $[75];
  }
  const t54 = t53.insuranceAndWarranty;
  let t55;
  if ($[76] !== t) {
    t55 = t("products.warranty.title");
    $[76] = t;
    $[77] = t55;
  } else {
    t55 = $[77];
  }
  let t56;
  if ($[78] !== t55) {
    t56 = {
      icon: t52,
      to: t54,
      testId: "ourProductsTableWarranty",
      analyticsParam: "ourProductsTableWarranty",
      title: t55
    };
    $[78] = t55;
    $[79] = t56;
  } else {
    t56 = $[79];
  }
  let t57;
  let t58;
  if ($[80] === Symbol.for("react.memo_cache_sentinel")) {
    t57 = <IconCard className="h-7 w-7" />;
    t58 = LINKS();
    $[80] = t57;
    $[81] = t58;
  } else {
    t57 = $[80];
    t58 = $[81];
  }
  const t59 = t58.card;
  let t60;
  if ($[82] !== t) {
    t60 = t("products.card.title");
    $[82] = t;
    $[83] = t60;
  } else {
    t60 = $[83];
  }
  let t61;
  if ($[84] !== t60) {
    t61 = {
      icon: t57,
      to: t59,
      testId: "ourProductsTableCard",
      analyticsParam: "ourProductsTableCard",
      title: t60
    };
    $[84] = t60;
    $[85] = t61;
  } else {
    t61 = $[85];
  }
  let t62;
  let t63;
  if ($[86] === Symbol.for("react.memo_cache_sentinel")) {
    t62 = <IconInstallments className="h-7 w-7" />;
    t63 = LINKS();
    $[86] = t62;
    $[87] = t63;
  } else {
    t62 = $[86];
    t63 = $[87];
  }
  const t64 = t63.installments;
  let t65;
  if ($[88] !== t) {
    t65 = t("products.installments.title");
    $[88] = t;
    $[89] = t65;
  } else {
    t65 = $[89];
  }
  let t66;
  if ($[90] !== t65) {
    t66 = {
      icon: t62,
      to: t64,
      testId: "ourProductsTableInstallment",
      analyticsParam: "ourProductsTableInstallment",
      title: t65
    };
    $[90] = t65;
    $[91] = t66;
  } else {
    t66 = $[91];
  }
  let t67;
  let t68;
  if ($[92] === Symbol.for("react.memo_cache_sentinel")) {
    t67 = <IconExtend className="h-7 w-7" />;
    t68 = LINKS();
    $[92] = t67;
    $[93] = t68;
  } else {
    t67 = $[92];
    t68 = $[93];
  }
  const t69 = t68.postponeDueDate;
  let t70;
  if ($[94] !== t) {
    t70 = t("products.postponeDueDate.title");
    $[94] = t;
    $[95] = t70;
  } else {
    t70 = $[95];
  }
  let t71;
  if ($[96] !== t70) {
    t71 = {
      icon: t67,
      to: t69,
      testId: "ourProductsTablePostponeDueDate",
      analyticsParam: "ourProductsTablePostponeDueDate",
      title: t70
    };
    $[96] = t70;
    $[97] = t71;
  } else {
    t71 = $[97];
  }
  let t72;
  let t73;
  if ($[98] === Symbol.for("react.memo_cache_sentinel")) {
    t72 = <IconPayment className="h-7 w-7" />;
    t73 = LINKS();
    $[98] = t72;
    $[99] = t73;
  } else {
    t72 = $[98];
    t73 = $[99];
  }
  const t74 = t73.bankTransfer;
  let t75;
  if ($[100] !== t) {
    t75 = t("products.bankTransfer.title");
    $[100] = t;
    $[101] = t75;
  } else {
    t75 = $[101];
  }
  let t76;
  if ($[102] !== t75) {
    t76 = {
      icon: t72,
      to: t74,
      testId: "ourProductsTableBankTransfer",
      analyticsParam: "ourProductsTableBankTransfer",
      title: t75
    };
    $[102] = t75;
    $[103] = t76;
  } else {
    t76 = $[103];
  }
  let t77;
  if ($[104] !== t) {
    t77 = shouldShowSpringOffer ? [{
      icon: <IconTulip className="h-7 w-7" />,
      to: LINKS().youShopWePay,
      testId: "ourProductsTableSpringPromo",
      analyticsParam: "ourProductsTableSpringPromo",
      title: t("products.revolving.springPromo.title")
    }] : [];
    $[104] = t;
    $[105] = t77;
  } else {
    t77 = $[105];
  }
  let t78;
  if ($[106] !== t41 || $[107] !== t46 || $[108] !== t51 || $[109] !== t56 || $[110] !== t61 || $[111] !== t66 || $[112] !== t71 || $[113] !== t76 || $[114] !== t77) {
    t78 = [t41, t46, t51, t56, t61, t66, t71, t76, ...t77].map(_temp2);
    $[106] = t41;
    $[107] = t46;
    $[108] = t51;
    $[109] = t56;
    $[110] = t61;
    $[111] = t66;
    $[112] = t71;
    $[113] = t76;
    $[114] = t77;
    $[115] = t78;
  } else {
    t78 = $[115];
  }
  let t79;
  if ($[116] !== t29 || $[117] !== t30 || $[118] !== t31 || $[119] !== t36 || $[120] !== t78) {
    t79 = <Box icon={t28} title={t29} text={t30} badge={t31} footer={t36}>{t78}</Box>;
    $[116] = t29;
    $[117] = t30;
    $[118] = t31;
    $[119] = t36;
    $[120] = t78;
    $[121] = t79;
  } else {
    t79 = $[121];
  }
  let t80;
  if ($[122] !== t27 || $[123] !== t79) {
    t80 = <div className="flex w-full flex-col-reverse flex-wrap items-center justify-center gap-4 p-4 md:flex-row md:items-baseline md:gap-8 [&>*]:max-w-106">{t27}{t79}</div>;
    $[122] = t27;
    $[123] = t79;
    $[124] = t80;
  } else {
    t80 = $[124];
  }
  let t81;
  if ($[125] !== t2 || $[126] !== t80) {
    t81 = <div className="mx-auto flex max-w-292 flex-col gap-4 md:gap-8">{t2}{t80}</div>;
    $[125] = t2;
    $[126] = t80;
    $[127] = t81;
  } else {
    t81 = $[127];
  }
  return t81;
}
function _temp2(item_0, key_0) {
  return <FilledButton key={key_0} {...item_0} className="w-full! shadow-none" variant="sm">{item_0.title}</FilledButton>;
}
function _temp(item, key) {
  return <FilledButton key={key} {...item} className="w-full! shadow-none" variant="sm">{item.title}</FilledButton>;
}